import { createApp } from "vue";
import "./reset.css"; // 初始化样式
import "/node_modules/flag-icons/css/flag-icons.min.css"; // 引入各国国旗
import "vant/lib/index.css"; // 引入 Vant 样式
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import { i18n } from "./language";
import { Buffer } from "buffer";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import vThrottleClick from "./utils/throttleClick";
import { Swipe, SwipeItem, Picker, Popup, Field } from "vant";
import { updateManifest } from "./utils/common";
import { initPwaNavRestore } from "./utils/pwaNav";
import emitter from "./utils/bus";

window.Buffer = Buffer;
// PWA：使用服务端渲染的全局配置生成 manifest
updateManifest(
  TApp_GlobalConfig.client_config?.miniapp_info?.name,
  TApp_GlobalConfig.client_config?.miniapp_info?.iconUrl,
);

let app = createApp(App);
app.directive("throttle-click", vThrottleClick); // 注册全局指令

app
  .use(VueSweetalert2)
  .use(createPinia())
  .use(router)
  .use(i18n)
  .use(Picker)
  .use(Popup)
  .use(Field)
  .use(Swipe)
  .use(SwipeItem)
  .use(Picker)
  .use(Popup);

app.mount("#app");

// PWA 导航恢复初始化
// 在 router.isReady() 之后初始化，确保路由已就绪
router.isReady().then(() => {
  initPwaNavRestore(router, {
    // 任务状态恢复回调
    onTaskRestore: (taskState) => {
      if (taskState) {
        // 通过事件总线通知任务组件恢复状态
        emitter.emit("pwaTaskRestore", taskState);
      }
    },
    // 自定义状态恢复回调（可根据需要扩展）
    onCustomRestore: (customState) => {
      if (customState) {
        emitter.emit("pwaCustomRestore", customState);
      }
    },
  });
});
